import { UserPermissions } from './PermissionsEnum';

export const PERMISSIONS = [
    {
        resource: UserPermissions.SERVICE,
        label: 'app.resource.service',
        actions: ['read', 'write'],
        route: '/services',
    },
    {
        resource: UserPermissions.IEVENTS,
        label: 'app.resource.ievents',
        actions: ['read', 'write'],
        route: '/i-events',
    },
    {
        resource: UserPermissions.ISTORE,
        label: 'app.resource.istore',
        actions: ['read', 'write'],
        route: '/i-store',
    },
    {
        resource: UserPermissions.LEAD,
        label: 'app.resource.lead',
        actions: ['read', 'write'],
        route: '/leads',
    },
    {
        resource: UserPermissions.QR_CONFIRMATION,
        label: 'app.resource.qrConfirmation',
        actions: ['read', 'write'],
        route: '/qr-confirmation',
    },
    // { resource: 'event', label: 'app.resource.event', actions: ['read', 'write'] },
    // { resource: 'user', label: 'app.resource.user', actions: ['read', 'write'] },
    // { resource: 'asset', label: 'app.resource.asset', actions: ['read', 'write'] },
];
